import React from "react"
import { Redirect } from "react-router-dom"
import { FormattedMessage, useIntl } from "react-intl"
import { SEO } from "../../../../components/Seo/seo"
import { promocodes } from '../../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from "../../../../AuthenticatedUserContext"
import { FormLoader } from "../../../../components/Loader/FormLoader"
import { NamedRoutes } from "../../../../routes"
import PromocodeEditContent from "../../../../components/Dashboard/Subscription/PromocodeEditContent"
import Layout from "../../../../components/Dashboard/Layout/Layout"
import { PromocodeProvider } from "../../../../PromocodeContext"

const SinglePromocodeAdd = () => {
  const intl = useIntl()

  return (
    <>
      <SEO title={intl.formatMessage({ id: 'Promocodes.List.AddPromocode.Title' })}
        pathname={window.location.origin}
        titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
        image={promocodes.image}
        description={intl.formatMessage({ id: 'Promocodes.List.AddPromocode.Title' })}
      />
      <AuthenticatedUserConsumer>
        {({ userDataLoading, userData, handleNotificationCall }) => (
          <>
            {!!userDataLoading && <FormLoader loading={true} />}
            {!!Object.keys(userData).length &&
              <>
                {!!userData.is_admin ?
                  <Layout content={
                    <PromocodeProvider handleNotificationCall={handleNotificationCall}>
                      <PromocodeEditContent
                        pageTitle={<FormattedMessage id='Promocodes.List.AddPromocode.Title' />}
                        handleNotificationCall={handleNotificationCall}
                      />
                    </PromocodeProvider>
                  } />
                  :
                  (!userDataLoading && <Redirect to={NamedRoutes.home} />)
                }
              </>
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </>
  )
}
export default SinglePromocodeAdd